import { useShallow } from 'zustand/react/shallow';
import { useRef, useEffect } from 'react';
import useAuthStore from '../auth.store.js';
import { getCurrentUser } from '../services/user.service.js';
import { isWeb } from '../platform.js';

const useAuth = ()=>{
    const { isLoggedIn, isInitializing, user } = useAuthStore(useShallow((store)=>({
            isLoggedIn: store.isLoggedIn,
            isInitializing: store.isInitializing,
            user: store.user
        })));
    const hasCheckedRef = useRef(false);
    useEffect(()=>{
        // Only check session once globally and only if we don't have user data
        if (hasCheckedRef.current || user || !isWeb()) {
            return;
        }
        hasCheckedRef.current = true;
        getCurrentUser().then((currentUser)=>{
            if (currentUser) {
                useAuthStore.getState().setIsLoggedIn(true);
                console.log('Found existing user session');
            } else {
                console.log('No existing user session found');
            }
        }).catch((error)=>{
            console.error('Error checking user session:', error);
        });
    }, [
        user
    ]);
    return {
        isLoggedIn,
        isInitializing
    };
};

export { useAuth as default };
//# sourceMappingURL=useAuth.js.map
